import { jeepRallyApi } from "../api";

const baseUrl = "/api/v1/rally";

export const getRankingsByEvent = (eventId, params = {}) => {
  return jeepRallyApi.get(`${baseUrl}/${eventId}/rankings`, { params });
};

export const setRankingsByEvent = (eventId, payload) => {
  return jeepRallyApi.post(`${baseUrl}/${eventId}/rankings`, payload);
};
